
import { useState, useEffect } from 'react';
import { useSEO, generateWebPageSchema } from '../../utils/seo';
import BlogNavbar from './components/BlogNavbar';
import BlogHero from './components/BlogHero';
import FeaturedPosts from './components/FeaturedPosts';
import BlogGrid from './components/BlogGrid';
import NewsletterSection from './components/NewsletterSection';
import BlogFooter from './components/BlogFooter';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function BlogPage() {
  const [scrolled, setScrolled] = useState(false);

  // SEO Configuration
  useSEO({
    title: 'Blog NeuroAgents - Artigos sobre IA, Automação e Atendimento Inteligente',
    description: 'Aprenda sobre inteligência artificial, automação de processos, chatbots inteligentes e tendências de IA para atendimento ao cliente. Guias práticos, tutoriais e casos de sucesso reais.',
    keywords: 'blog IA, artigos inteligência artificial, automação atendimento, chatbots inteligentes, tendências IA 2025, tutorial whatsapp business, ROI inteligência artificial',
    canonical: '/blog',
    type: 'website',
    jsonLd: generateWebPageSchema({
      name: 'Blog NeuroAgents - IA e Automação',
      description: 'Artigos sobre inteligência artificial, automação de processos e atendimento inteligente',
      url: '/blog',
    }),
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <BlogNavbar scrolled={scrolled} />
      <BlogHero />
      <FeaturedPosts />
      <BlogGrid />
      <NewsletterSection />
      <BlogFooter />
      <WhatsAppButton />
    </div>
  );
}
